import {
  EmployeeExpectationsPayload,
  employeeExpectationsRequest,
} from "~/pages/Editor/EditorStaff/requests/employeeExpectationsRequest";

export async function addEmployeeExpectations(
  data: EmployeeExpectationsPayload,
) {
  return employeeExpectationsRequest("POST", data);
}
